module.exports = __webpack_public_path__ + "img/Texas-Star.5104d9a7.png";